import Slideout from "slideout";

const slideoutMenuElem = document.getElementById("menu");
if (slideoutMenuElem) {
    const slideout = new Slideout({
        panel: document.getElementById("clarius-panel"),
        menu: slideoutMenuElem,
        padding: 256,
        tolerance: 70,
        grabWidth: 40,
    });

    // Toggle button
    globalThis.toggleSidebar = function () {
        slideout.toggle();
    };
}

export const inst_id = JSON.parse(document.getElementById("inst-id").textContent);
